export const SET_USERS = 'setUsers'
export const SET_PAGES = 'setPages'
export const SET_GROUPS = 'setGroups'
export const SET_ROLES = 'setRoles'
export const SET_TOKEN_VALID = 'setTokenValid'
export const SET_QUIZ_DETAILS   =   'setQuizDetails'
export const SET_INDIVIDUAL_GROUP = 'setIndividualGroup'
export const SET_NAVIGATION_BAR_STATUS = 'setNavigationBarStatus'
export const SET_INDIVIDUAL_USER = 'setIndividualUser'
export const SET_INDIVIDUAL_EQUIPMENT =   'setIndividualEquipment'
export const SET_USER_DOCUMENTS =   'setUserDocuments'
export const SET_INDIVIDUAL_PAGE  =   'setIndividualPage'
export const SET_STRIPE_SECRET_KEY = 'setStripeSecretKey'
export const SET_QUIZ_DATA = 'setQuizData'
export const SET_AUTH = "setUser"
export const SET_LOGGED_IN = "setLoggedIn"
export const SET_DOCUMENTS_ERROR = 'setDocumentsError'
export const SET_INVOICES = 'setInvoices'
export const SET_LOADING = 'setLoading'
export const SET_LANGUAGES    =   'setLanguages'
export const PURGE_AUTH = 'logOut'
export const SET_STRIPE_ALL_CARDS ='setStripeAllCards'
export const SET_ROUTER_ENTER = 'setRouterEnter'
export const SET_NAVBAR_WIDTH   = 'setNavbarWidth'
export const SET_USER_STATUS = 'setUserStatus'
export const SET_ERROR_USER = 'setErrorUser'
export const SET_CUR_LANGUAGE = 'setCurrentLanguage'
export const SET_SNACKBAR   =   'setSnackbar'
export const SET_RESPONSE = 'setResponse'
export const SET_ERROR = 'setError'
export const SET_ERROR_CONTACT = 'setContactError'
export const SET_ERROR_EQUIPMENT    =   'setEquipmentError'
export const SET_ERROR_GROUPS   =   'setEquipmentGroups'
export const SET_AUTH_ERROR = 'setAuthError'
export const UPLOAD_CSV_USERS = 'uploadCsvUsers'
export const STATE_RESET    =   'stateReset'
export const RESET_STRIPE_STATE ='StripeStatereset'
export const RESET_LANGUAGES_STATE = 'StateLanguagereset'
export const RESET_USER_STATE   = 'userStateReset'
export const RESET_PAGES_STATE = 'PagesStatereset'
export const RESET_EQUIPMENTS_STATE = 'equipmentsStateReset'
export const RESET_GROUPS_STATE = 'groupsStateReset'
export const RESET_ROLES_STATE = 'rolesStateReset'
export const SET_EQUIPMENTS = 'setEquipments'
export const RESET_GLOBAL_STATE =   'globalStateReset'
export const SET_MODULES = 'setModules'
export const SET_INDIVIDUAL_MODULE = 'setIndividualModule'
export const SET_COURSES = 'setCourse'
export const SET_GENERAL_DOCUMENTS = 'setGeneralDocuments'
export const SET_PERSONAL_DOCUMENTS =   'setPersonalDocuments'
export const SET_USER_REGISTRATION_STATUS  =   'setUserRegistrationStatus'
export const SET_ALLOWED_EMAIL_DOMAINS  =   'setAllowedEmailDomains'
export const SET_LOGIN_OPTIONS  =   'setLoginOptions'
export const SET_INBOX_SETTINGS =   'setInboxSettings'
export const SET_DOCUMENT =   'setDocument'
export const SET_LEARNING_SESSION_DATA  =   'setLearningSessionData'
export const SET_GROUP_USERS  =   'setGroupUsers'
export const SET_ADMIN_USERS  =   'setAdminUsers'
export const SET_COMPANY_SETTINGS  =   'setCompanySettings'
export const SET_DASHBOARD_DATA   =   'setDashboardData'
export const SET_DASHBOARD_LAST_COURSES   =   'setDashboardLastCourses'
export const SET_DASHBOARD_DOCUMENTS   =   'setDashboardDocuments'
export const SET_SESSION_TIME_DATA   =   'setSessionTimeData'
export const SET_DASHBOARD_QUIZ_DATA   =   'setQuizData'
export const SET_DASHBOARD_COURSE_QUIZ   =   'setDashboardCourseQuiz'
export const RESET_ALL_PAGES_DATA = 'resetAllPagesData'
export const SET_DASHBOARD_STATS_DATA = 'setDashboardStatsData'
export const SET_DASHBOARD_COURSE_EVENTS = 'setDashboardCourseEvents'
export const RESET_COURSES_DATA  =   'resetCousesData'
export const SET_REMINDER_EMAIL = "setReminderEmail"
export const SET_INDIVIDUAL_REMINDER_EMAIL = "setIndividualReminderEmail"
export const SET_ERROR_REMINDER_EMAIL = "setErrorReminderEmail"
export const SET_VIDEO_DATA = 'setVideoData'
export const SET_EQUIPMENT_GROUP_DATA = 'setEquipmentGroupData'
export const SET_EQUIPMENT_GROUP_INDIVIDUAL_DATA = 'setEquipmentGroupIndividualData'
export const SET_ERROR_EQUIPMENT_GROUP = "setErrorEquipmentGroup"
export const SET_EQUIPMENT_TEMPLATE_DATA = 'setEquipmentTemplateData'
export const SET_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA = 'setEquipmentTemplateIndividualData'
export const SET_INDIVIDUAL_PERSONAL_DOCUMENT = 'setIndividualPersonalDocumentData'
export const SET_ERROR_EQUIPMENT_TEMPLATE = "setErrorEquipmentTemplate"
export const SET_TEST_GROUP = 'setTestGroup'
export const SET_CREATE_DOCUMENT = 'setCreateDocuments'
export const SET_INDIVIDUAL_TEST_GROUP = 'setIndividualTestGroup'
export const SET_ERROR_TEST_GROUP = 'setErrorTestGroup'
export const SET_TEST_CASE_TEMPLATE_DATA = 'setTestCaseTemplateData'
export const SET_TEST_CASE_TEMPLATE_INDIVIDUAL_DATA = 'setTestCaseTemplateIndividualData'
export const SET_ERROR_TEST_CASE_TEMPLATE_DATA= 'setErrorTestCaseTemplateData'
export const SET_EQUIPMENT_LABEL = 'setEquipmentLabel'
export const SET_ERROR_EQUIPMENT_LABEL = 'setErrorEquipmentLabel'
export const SET_TEST_CASE = 'setTestCase'
export const SET_INDIVIDUAL_TEST_CASE = 'setIndividualTestCase'
export const SET_ERROR_TEST_CASE = 'setErrorTestCase'
export const SET_USER_CERTIFICATES = 'setUserCertificates'
export const SET_INDIVIDUAL_COURSE = 'setIndividualCourses'
export const SET_DRAFT_COURSES = 'setDraftCourses'
export const SET_VOUCHERS = 'setVouchers'
export const SET_COUPONS = 'setCoupons'
export const SET_TUTOR_PRODUCTS = 'setTutorProducts'
export const SET_TUTOR_VOUCHERS = 'setTutorVouchers'
export const SET_TUTOR_COUPONS = 'setTutorCoupons'
export const SET_QUESTION = 'setQuestion'
export const SET_INDIVIDUAL_QUESTION = 'setIndividualQuestion'
export const SET_ERROR_QUESTION = 'setErrorQuestion'
export const SET_QUESTION_TOPIC = 'setQuestionTopic'
export const SET_ANSWER = 'setAnswer'
export const SET_INDIVIDUAL_ANSWER = 'setIndividualAnswer'
export const SET_ERROR_ANSWER = 'setErrorAnswer'
export const SET_QUIZ = 'setQuiz'
export const SET_INDIVIDUAL_QUIZ = 'setIndividualQuiz'
export const SET_ERROR_QUIZ = 'setErrorQuiz'
export const SET_USER_ANSWERS = 'setUserAnswers'
export const SET_ERROR_USER_ANSWERS = 'setErrorUserAnswers'
export const SET_CUR_USER_LANGUAGE = 'setCurUserLanguage'
export const SET_PERMISSIONS = 'setPermissions'
export const SET_CUSTOM_ROLES = 'setCustomRoles'
export const SET_INDIVIDUAL_CUSTOM_ROLE = 'setIndividualCustomRole'
export const SET_ERROR_CUSTOM_ROLE = 'setErrorCustomRole'
export const SET_PERMISSION_LABELS = 'setPermissionLabels'
export const SET_USER_LOG = 'setUserLog'
export const SET_EMAIL_TYPES = 'setEmailTypes'
export const SET_MAIL_PLACEHOLDERS = 'setMailPlaceholders'
export const SET_EMAIL_TEMPLATES = 'setEmailTemplates'
export const SET_INDIVIDUAL_TEMPLATE = 'setIndividualTemplate'
export const SET_ERROR_TEMPLATE = 'setErrorTemplate'
export const SET_TRIGGERED_EMAIL_TYPES = 'setTriggeredEmailTypes'
export const SET_COURSE_STATS = 'setCourseStats'
export const SET_GROUP_STATS = 'setGroupStats'
export const SET_USER_STATS = 'setUserStats'
export const SET_ERROR_STATS = 'setErrorStats'
export const SET_INBOX_MESSAGES = 'setInboxMessages'
export const SET_SENT_MESSAGES = 'setSentMessages'
export const SET_INDIVIDUAL_NOTIFICATION = 'setIndividualNotification'
export const SET_INBOX_COUNTER = 'setInboxCounter'
export const SET_ADDITIONAL_PAGES = 'setAdditionalPages'
export const SET_RESOURCES = 'setResources'
export const SET_ERROR_PAGE = 'setErrorPage'
export const SET_INDIVIDUAL_ADDITIONAL_PAGE = 'setIndividualPage'
export const SET_ADDITIONAL_PAGES_ON_SIDE_MENU = 'resetAdditionalPagesSideMenu'
export const RESET_ALL_ADDITIONAL_PAGES_DATA = 'resetAllAdditionalPagesData'
export const SET_SURVEY = 'setSurvey'
export const SET_INDIVIDUAL_SURVEY = 'setIndividualSurvey'
export const SET_ERROR_SURVEY = 'setErrorSurvey'

export const SET_TEST_EXAM = 'setTestExam'
export const SET_TEST_DATA = 'setTestExam'
export const SET_EXAM_DATA = 'setTestExam'
export const SET_INDIVIDUAL_TEST_EXAM = 'setIndividualTestExam'
export const SET_ERROR_TEST_EXAM = 'setErrorTestExam'
export const SET_DETAILED_INDIVIDUAL_TEST_EXAM = 'setDetailedIndividualTestExam'

export const SET_EXERCISES = 'setExercises'
export const SET_INDIVIDUAL_EXERCISE = 'setIndividualExercises'
export const SET_ERROR_EXERCISE = 'setErrorExercises'
export const SET_OPEN_EXERCISES = 'setOpenExercises'
export const SET_UPLOAD_EXERCISE_DATA = 'setUploadExerciseData'
export const SET_AVAILABLE_EXERCISES = 'setAvailableExercises'

export const SET_CALENDARS = 'setCalendars'
export const SET_CALENDAR_EVENTS = 'setCalendarEvents'
export const SET_CALENDAR_PAST_EVENTS = 'setCalendarPastEvents'


